import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { CollaborationReadApiClient, People } from '~/services/Http';
import { TaskStatusEnum } from '~/services/Http/client.people.generated';

export const GET_TEAM_WORKLISTS_SWR_KEY =
  'CollaborationReadApiClient.getTeamWorklists';

export function useGetTeamWorklists(args: {
  employeeId: string;
  order?: People.Order11;
  offset?: number;
  limit?: number;
  lang?: string;
  treeId?: string;
  statuses?: TaskStatusEnum[] | undefined;
  roles?: string[];
}): UseArraySWROutput<People.WorklistDto> {
  return useArraySWR(
    [
      GET_TEAM_WORKLISTS_SWR_KEY,
      args.employeeId,
      args?.order ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.lang ?? undefined,
      args?.treeId ?? undefined,
      args?.statuses ?? undefined,
      args?.roles ?? undefined,
    ],
    ([_, employeeId, order, offset, limit, lang, treeId, statuses, roles]) => {
      return CollaborationReadApiClient.getTeamWorklists(
        employeeId,
        order,
        offset,
        limit,
        lang,
        treeId,
        statuses,
        roles,
      ).then((r) => r.data);
    },
  );
}
